import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import type { MediaFormBrandType, MediaBrandForms } from '../mediaTypes'
import VideoFormFonts from './VideoFormFont'
import VideoFormStyle from './VideoFormStyle'

const FORM_MAP: MediaBrandForms = {
  [BrandFormEnum.STYLE]: VideoFormStyle,
  ...VideoFormFonts,
}

const VideoFormBrand: MediaFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(VideoFormBrand) as typeof VideoFormBrand
